import { gql } from "@apollo/client";

export const UPDATE_CUSTOMER = gql`
mutation UpdateCustomer($id: Int!, $customer: CustomerInput!) {
  updateCustomer(id: $id, customer: $customer) {
    _id
    id
    business_name
    firstname
    lastname
    fullname
    email
    phone
    address
    address_2
    city
    state
    zip
    business_and_full_name
    created_at
    updated_at
    daily_invoices
    purchase_order_email {
      email
    }
  }
}`;